export default __webpack_public_path__ + "static/Azure-Window-Gozo-credit-JuanAntonioFSegal-be50216d33bb6d85f40d5641a2464891.jpg";